import { ReactSVG } from "react-svg";

const SkeletonTable = () => {
  return (
    <main className="-mt-32 pb-48">
      <div className="max-w-7xl mx-auto pb-12 px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col">
          <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
              <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg relative">
                <div className="z-1 top-0 right-0 bottom-0 left-0 absolute flex flex-col justify-center place-items-center">
                  <ReactSVG src={'../../assets/mvsf-spinner-white.svg'} className="mx-auto h-12 w-auto" />
                </div>
                <table className="z-0 min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th
                        scope="col"
                        className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        <div className="h-3 bg-gray-300 animate-pulse rounded"></div>
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        <div className="h-3 bg-gray-300 animate-pulse rounded"></div>
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        <div className="h-3 bg-gray-300 animate-pulse rounded"></div>
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        <div className="h-3 bg-gray-300 animate-pulse rounded"></div>
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {[...new Array(5)].map((item, i) => (
                      <tr key={i}>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <div className="h-2 bg-gray-200 animate-pulse rounded mb-2"></div>
                          <div className="h-2 bg-gray-100 animate-pulse rounded"></div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <div className="h-2 bg-gray-200 animate-pulse rounded mb-2"></div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <div className="h-2 bg-gray-200 animate-pulse rounded mb-2"></div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                          <div className="h-2 bg-gray-200 animate-pulse rounded mb-2"></div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default SkeletonTable;
